import React, { Component, Fragment } from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import validateEmail from 'helpers/emailValidator';

import { localizable } from 'components/Localization';

@localizable
class EmailField extends Component {
  emailField = null;

  validate = (value) => {
    var { onGetErrorMessage: originalOnGetErrorMessage, t } = this.props;

    var result = validateEmail(value);
    if (!result) return t('Invalid e-mail');

    if (originalOnGetErrorMessage) return originalOnGetErrorMessage(value);

    return '';
  };

  render() {
    var { onGetErrorMessage: _, ...rest } = this.props;

    return (
      <Fragment>
        <TextField
          onGetErrorMessage={this.validate}
          componentRef={(ref) => (this.emailField = ref)}
          inputMode="email"
          {...rest}
        />
      </Fragment>
    );
  }
}

export default EmailField;



// WEBPACK FOOTER //
// ./src/app/components/EmailField/index.jsx